export default {
  server: {
    host: window.Settings.API_BASE_URL,
    ns: window.Settings.API_NS
  }
}